import React, { Component } from 'react'

import TestAccessory from './TestAccessory'
import IconRender from '../std/IconRender';

class TestAccessories extends Component {

	handleAccessoryChange(data, index) {
		var list = [];
		for (var k in this.props.data) {
			var occ = this.props.data[k];
			if (k - index === 0) {
				list.push(data);
			} else {
				list.push(occ);
			}
		}
		this.props.onChangeAccessories(list);
	}
	handleAccessoryDelete(key) {
		var list = [];
		for (var k in this.props.data) {
			var occ = this.props.data[k];
			if (occ.key !== key) {
				list.push(occ);
			}
		}
		this.props.onChangeAccessories(list);
	}
	handleAccessoryCopy(key) {
		var list = this.props.data != null ? [...this.props.data] : [];
		var occCopy = null;
		var indexSuffix = list.length + 1;
		for (var k in this.props.data) {
			var occ = this.props.data[k];
			if (occ.key === key) {
				occCopy = { ...occ };
			}
			if (occ.key === `accessory${indexSuffix}`) {
				indexSuffix++;
			}
		}
		if (occCopy != null) {
			occCopy.key = `accessory${indexSuffix}`;
			list.push(occCopy);
			this.props.onChangeAccessories(list);
		}
	}
	handleAccessoryAdd() {
		var list = this.props.data != null ? [...this.props.data] : [];
		var size = list.length + 1;
		list.push({ key: `accessory${size}`, pricing: {}, isMounted: null });
		this.props.onChangeAccessories(list);
	}

	render() {
		return (
			<div className="row">
				{this.props.data && this.props.data.map((occurence, index) => (
					<div key={index} className="row shadow-sm m-1 p-1">
						<TestAccessory data={occurence} settings={this.props.settings} onChange={(data) => { this.handleAccessoryChange(data, index) }} />
						<div className="col-auto">
							<button className="btn btn-light" onClick={() => this.handleAccessoryDelete(occurence.key)} >
								<IconRender name="trash" />
							</button>
						</div>
						<div className="col-auto">
							<button className="btn btn-light" onClick={() => this.handleAccessoryCopy(occurence.key)} >
								<IconRender name="stickies" />
							</button>
						</div>
					</div>
				))}
				<div className="col-auto">
					<button className="btn btn-light" onClick={() => this.handleAccessoryAdd()} >
						<IconRender name="plus" />
					</button>
				</div>
			</div>
		)
	}
}

export default (TestAccessories)
